import { isEmptyOrNull } from "../utils/DataUtils";
import { API_BASIC_URL_SLOT_SERVICE, DELIVERY_TYPE } from "../config/constants";
import { handleError, handleResponse } from "./ApiUtils";
import Fetch from "./Fetch";

export const addNewTemplateSlot = (data) => {
  return Fetch.create(`${API_BASIC_URL_SLOT_SERVICE}/api/v1`, data).then(handleResponse).catch(handleError);
};

export const updateTemplateSlot = (data) => {
  if (!isEmptyOrNull(data?.serviceTypeId) && data?.deliveryType === DELIVERY_TYPE.DAY_BASED) {
    return Fetch.update(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/default`, data).then(handleResponse).catch(handleError);
  } else {
    return Fetch.update(`${API_BASIC_URL_SLOT_SERVICE}/api/v1`, data).then(handleResponse).catch(handleError);
  }
};

export const deleteTemplateSlot = (slotId) => {
  return Fetch.patch(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/${slotId}`).then(handleResponse).catch(handleError);
};

export const deleteDefaultTemplateSlot = (slotId) => {
  return Fetch.remove(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/default/${slotId}`).then(handleResponse).catch(handleError);
};

export const sendConfigurationForApprovalAPI = (data) => {
  return Fetch.create(`${API_BASIC_URL_SLOT_SERVICE}/approval/template-slots`, data).then(handleResponse).catch(handleError);
};
